import {space} from "../compiled";
import IErrorProto = space.kenko.proto.IErrorProto;

/**
 * Finds a single error with the given path.
 */
export const findError = (errors: IErrorProto[] | null | undefined, path: string) => {
  if (!errors) {
    return null;
  }

  for (let i = 0; i < errors.length; i++) {
    if (errors[i].path == path) {
      return errors[i].error;
    }
  }
  return null;
}

